/**
 * @file Definition of all the messages that can be sent between web and native.
 */
/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * A function that constructs a payload for a message that can be sent from web to native.
 */
type NativeBridgePayloadOnlyConstructor = (...args: any[]) => any

type NativeBridgePayloadWithReplyConstructor = {
  payload: NativeBridgePayloadOnlyConstructor
  reply: NativeBridgePayloadOnlyConstructor
}

type NativeBridgeMessageConstructor = NativeBridgePayloadOnlyConstructor | NativeBridgePayloadWithReplyConstructor

/**
 * A manifest of all the messages that can be sent between web and native.
 */
type NativeBridgeManifest = {
  webToNative: {
    [messageType: string]: NativeBridgeMessageConstructor
  }
  nativeToWeb: {
    [messageType: string]: NativeBridgeMessageConstructor
  }
}

/**
 * Convenient function to create a typesafe manifest without losing type
 * information.
 */
function createNativeBridgeManifest<TManifest extends NativeBridgeManifest>(manifest: TManifest): TManifest {
  return manifest
}

function isPayloadWithReplyConstructor(
  constructor: NativeBridgeMessageConstructor,
): constructor is NativeBridgePayloadWithReplyConstructor {
  return (
    typeof constructor === 'object' &&
    typeof constructor.reply === 'function' &&
    typeof constructor.payload === 'function'
  )
}

export { createNativeBridgeManifest, isPayloadWithReplyConstructor }
export type {
  NativeBridgeMessageConstructor,
  NativeBridgePayloadOnlyConstructor,
  NativeBridgePayloadWithReplyConstructor,
}
export default NativeBridgeManifest
